/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ModelPriceRowRates = {
  inputTokens?: number | undefined;
  outputTokens?: number | undefined;
  cachedTokens?: number | undefined;
  reasoningTokens?: number | undefined;
  characters?: number | undefined;
  seconds?: number | undefined;
  image?: number | undefined;
  imageTiers?: { [k: string]: number } | undefined;
  searches?: number | undefined;
};

export type ModelPriceRow = {
  model: string;
  orgId: string | null;
  rates: ModelPriceRowRates;
  effectiveFrom: string;
  effectiveTo: string | null;
  setBy: string | null;
};

/** @internal */
export const ModelPriceRowRates$inboundSchema: z.ZodType<
  ModelPriceRowRates,
  z.ZodTypeDef,
  unknown
> = z.object({
  input_tokens: z.number().optional(),
  output_tokens: z.number().optional(),
  cached_tokens: z.number().optional(),
  reasoning_tokens: z.number().optional(),
  characters: z.number().optional(),
  seconds: z.number().optional(),
  image: z.number().optional(),
  image_tiers: z.record(z.number()).optional(),
  searches: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    "input_tokens": "inputTokens",
    "output_tokens": "outputTokens",
    "cached_tokens": "cachedTokens",
    "reasoning_tokens": "reasoningTokens",
    "image_tiers": "imageTiers",
  });
});
/** @internal */
export type ModelPriceRowRates$Outbound = {
  input_tokens?: number | undefined;
  output_tokens?: number | undefined;
  cached_tokens?: number | undefined;
  reasoning_tokens?: number | undefined;
  characters?: number | undefined;
  seconds?: number | undefined;
  image?: number | undefined;
  image_tiers?: { [k: string]: number } | undefined;
  searches?: number | undefined;
};

/** @internal */
export const ModelPriceRowRates$outboundSchema: z.ZodType<
  ModelPriceRowRates$Outbound,
  z.ZodTypeDef,
  ModelPriceRowRates
> = z.object({
  inputTokens: z.number().optional(),
  outputTokens: z.number().optional(),
  cachedTokens: z.number().optional(),
  reasoningTokens: z.number().optional(),
  characters: z.number().optional(),
  seconds: z.number().optional(),
  image: z.number().optional(),
  imageTiers: z.record(z.number()).optional(),
  searches: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    inputTokens: "input_tokens",
    outputTokens: "output_tokens",
    cachedTokens: "cached_tokens",
    reasoningTokens: "reasoning_tokens",
    imageTiers: "image_tiers",
  });
});

export function modelPriceRowRatesToJSON(
  modelPriceRowRates: ModelPriceRowRates,
): string {
  return JSON.stringify(
    ModelPriceRowRates$outboundSchema.parse(modelPriceRowRates),
  );
}
export function modelPriceRowRatesFromJSON(
  jsonString: string,
): SafeParseResult<ModelPriceRowRates, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ModelPriceRowRates$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ModelPriceRowRates' from JSON`,
  );
}

/** @internal */
export const ModelPriceRow$inboundSchema: z.ZodType<
  ModelPriceRow,
  z.ZodTypeDef,
  unknown
> = z.object({
  model: z.string(),
  org_id: z.nullable(z.string()),
  rates: z.lazy(() => ModelPriceRowRates$inboundSchema),
  effective_from: z.string(),
  effective_to: z.nullable(z.string()),
  set_by: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
    "effective_from": "effectiveFrom",
    "effective_to": "effectiveTo",
    "set_by": "setBy",
  });
});
/** @internal */
export type ModelPriceRow$Outbound = {
  model: string;
  org_id: string | null;
  rates: ModelPriceRowRates$Outbound;
  effective_from: string;
  effective_to: string | null;
  set_by: string | null;
};

/** @internal */
export const ModelPriceRow$outboundSchema: z.ZodType<
  ModelPriceRow$Outbound,
  z.ZodTypeDef,
  ModelPriceRow
> = z.object({
  model: z.string(),
  orgId: z.nullable(z.string()),
  rates: z.lazy(() => ModelPriceRowRates$outboundSchema),
  effectiveFrom: z.string(),
  effectiveTo: z.nullable(z.string()),
  setBy: z.nullable(z.string()),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
    effectiveFrom: "effective_from",
    effectiveTo: "effective_to",
    setBy: "set_by",
  });
});

export function modelPriceRowToJSON(modelPriceRow: ModelPriceRow): string {
  return JSON.stringify(ModelPriceRow$outboundSchema.parse(modelPriceRow));
}
export function modelPriceRowFromJSON(
  jsonString: string,
): SafeParseResult<ModelPriceRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ModelPriceRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ModelPriceRow' from JSON`,
  );
}
